<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        PROJECT PROGRESS
      </span>
    </div>
    <div class="wrapper-body">
      <a-card>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="search" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button
              :class="getScreen ? 'margin-top' : ''"
              block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
              @click="handleshowMore"
              >{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button
            >
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Budget Type</label>
              <a-select
                placeholder="Choose Budget Type"
                v-model="budget_type"
                class="width-full"
              >
                <a-select-option value="all">All Budget</a-select-option>
                <a-select-option
                  v-for="item in datasource.budget_type"
                  :key="item.value"
                  >{{ item.value }} - {{ item.text }}</a-select-option
                >
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Contract Period</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="contract_periode"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Due Date Inspection</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="due_date_inspection"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Status</label>
              <a-select
                placeholder="Choose Status"
                v-model="sts"
                class="width-full"
              >
              <a-select-option :key="2" :value="2">All Status</a-select-option>
                <a-select-option :key="0" :value="0">Open</a-select-option>
                <a-select-option :key="1" :value="1">Close</a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row>
      </a-card>
      <a-card>
        <a-config-provider :locale="getLocalConfigProvider()">
          <a-table bordered :columns="columns" :data-source="datasource.data" size="small" :pagination="false" :rowKey="(record, index) => {
                return index;
              }" :loading="table.loading"
              >
            <div slot="cc" slot-scope="data">
              <div>
                <b>
                  {{ data.cost_center_kode}}
                  <a-tooltip placement="bottomLeft">
                    <template #title>
                      <span>This data is editable for you</span>
                    </template>
                    <sup v-if="data.editable" class="tagsts">&nbsp;<a-icon type="check-circle" theme="filled"/></sup>
                  </a-tooltip>
                </b>
              </div>
              <div>{{ data.description}}</div>
            </div>
            <div slot="cp" slot-scope="data">
              {{ data.periode_start_dt ? moment(data.periode_start_dt).format(getDefaultDateFormat) : "-"}} ~ 
              {{ data.periode_end_dt ? moment(data.periode_end_dt).format(getDefaultDateFormat) : "-"}}
            </div>
            <div slot="ddi" slot-scope="data">
              {{ data.due_date_insp ? moment(data.due_date_insp).format(getDefaultDateFormat) : "-" }}
            </div>
            <div slot="lup" slot-scope="data">
              {{ data.last_update ? moment(data.last_update).format("DD-MM-YYYY HH:mm") : "-" }}
            </div>
            <div slot="pr" slot-scope="data">
              <a-progress stroke-linecap="square" :percent="Number(data.progress)" />
            </div>
            <div slot="ac" slot-scope="data">
              <div class="flex">
                <Status :status="data.sts_progress" color="red"></Status>
                <a-button
                  v-if="(data.editable && data.sts_project=='Aktif' && data.sts_progress=='Open') || (data.editable && data.sts_project!='Aktif' && data.sts_progress=='Open')"
                  size="small"
                  type="primary"
                  icon="edit"
                  :disabled="data.editable && data.sts_project!='Aktif' && data.sts_progress=='Open'"
                  :loading="openCloseProjectLoading.sts && openCloseProjectLoading.key==data.project_id"
                  @click="openCloseProject('Close', data.project_id, data.child)"
                ></a-button>
                <a-button
                  v-if="(data.editable && data.sts_project=='Aktif' && data.sts_progress=='Close') || (data.editable && data.sts_project!='Aktif' && data.sts_progress=='Close')"
                  size="small"
                  type="primary"
                  icon="edit"
                  :disabled="data.editable && data.sts_project!='Aktif' && data.sts_progress=='Close'"
                  :loading="openCloseProjectLoading.sts && openCloseProjectLoading.key==data.project_id"
                  @click="openCloseProject('Open', data.project_id, data.child)"
                ></a-button>
              </div>
            </div>
            <a-table
              slot="expandedRowRender"
              slot-scope="text" 
              :columns="innerColumns"
              :data-source="text.child"
              :pagination="false"
              :showHeader="false"
              size="small"
              style="padding: 5px"
              :rowKey="(record, index) => {
                return index;
              }"
            >
              <div slot="desc" slot-scope="data">
                <div>
                  <b>{{ data.actor.toUpperCase() }}</b>
                </div>
                <div v-if="data.tlc!='Finance'">
                  <b>PIC:</b> {{ data.tlc }}
                </div>
              </div>
              <div slot="prog" slot-scope="data">
                <a-progress stroke-linecap="square" :percent="Number(data.progress)" />
              </div>
              <span slot="operation" slot-scope="text" class="table-operation">
                <a-button
                  size="small"
                  type="dashed"
                  icon="history"
                  :loading="table.history && table.historyKey==(text.anggaran_id+text.actor)"
                  @click="handleClickHistory(text)"
                />
                <a-button
                  size="small"
                  type="danger"
                  icon="edit"
                  @click="handleClickEdit(text)"
                  class="margin-left"
                  :disabled="getAuth.username!=text.tlc"
                />
              </span>
            </a-table>
            <div slot="footer" style="text-align:right">
              <a-pagination v-model="currentPage" :total="datasource.total_items" show-less-items @change="onChangePagination"/>
            </div>
          </a-table>
        </a-config-provider>
      </a-card>
    </div>

    <a-modal
      v-if="modalHistory.visible"
      :visible="modalHistory.visible"
      @cancel="modalHistory.visible=false"
      :footer="null"
      width="900px"
    >
      <span slot="title">
        <a-icon :type="'history'" /> History
      </span>
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-table
          bordered
          :columns="historyColumns"
          :data-source="modalHistory.data"
          :pagination="false"
          size="small"
          :rowKey="(record, index) => {
            return index;
          }"
        >
          <div slot="pic" slot-scope="data">{{ data.pic }}</div>
          <div slot="date" slot-scope="data">{{ moment(data.create_dt).format(getDefaultDateFormat) }}</div>
          <div slot="progress" slot-scope="data"><a-progress stroke-linecap="square" :percent="Number(data.progress)" /></div>
          <div slot="note" slot-scope="data">{{ data.note }}</div>
        </a-table>
      </a-config-provider>
    </a-modal>

    <a-modal
      v-if="modalCreate.visible"
      :visible="modalCreate.visible"
      @ok="submitCreateEdit"
      @cancel="cancelmodalcreate"
      ok-text="Submit"
      cancel-text="Cancel"
      :maskClosable="false"
      :confirmLoading="modalCreate.loadingSave"
    >
      <span slot="title">
        <a-icon :type="modalCreate.type=='create' ? 'plus' : 'edit'" />&nbsp;{{modalCreate.type=='create' ? 'Create' : 'Edit'}} Project Progress
      </span>
      <div class="m-display-flex space-between">
        <div style="max-width: 70%;">
          <b>{{ modalCreate.data.actor.toUpperCase() }}</b>
        </div>
        <div style="max-width: 30%;">
          {{Number(modalCreate.data.progress)}}%
        </div>
        <a-progress stroke-linecap="square" :showInfo="false" :percent="Number(modalCreate.data.progress)" />
      </div>
      <a-divider></a-divider>
      <div class="m-display-flex space-between">
        <div style="max-width: 70%;">
          <b>{{ 'Reference Progress Nirmala'.toUpperCase() }}</b>
        </div>
        <div style="max-width: 30%;">
          {{Number(modalCreate.data.progres_nirmala)}}%
        </div>
        <a-progress stroke-linecap="square" :showInfo="false" :percent="Number(modalCreate.data.progres_nirmala)" />
      </div>
      <a-divider></a-divider>
      <a-form :form="formCreateEdit">
        <a-form-item label="Progress (%)">
          <a-input-number
            autocomplete="off"
            :min="0"
            :max="100"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['progress', { rules: [{ required: true }], initialValue: modalCreate.data.progress }]"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['note', { rules: [{ required: true }], initialValue: modalCreate.data.note }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "projectProgress-index",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      modalCreate:{
        visible: false,
        type: "",
        loadingSave: false,
        progress: 0,
        data: {
          progress: null,
          note: null
        }
      },
      table: {
        loading: false,
        history: false,
        historyKey: false,
      },
      datasource: [],
      search: "",
      budget_type: "all",
      sts: 0,
      advancedsearch: "display:none",
      currentPage: 1,
      contract_periode:[],
      due_date_inspection:[],
      timerTypeSearch: null,
      modalHistory:{
        visible: false,
        data: []
      },
      openCloseProjectLoading: {
        sts: false,
        key:""
      }
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
      "getAllKaryawan",
    ]),
    columns() {
      const columns = [
          {
            title: "Cost Center",
            key: "cc",
            scopedSlots: { customRender: "cc" },
            width: "35%",
          },
          {
            title: "Contract Period",
            key: "cp",
            scopedSlots: { customRender: "cp" },
            width: "15%",
            align: "center",
          },
          {
            title: "Due Date Inspection",
            key: "ddi",
            width: "10%",
            align: "center",
            scopedSlots: { customRender: "ddi" },
          },
          {
            title: "Last Update",
            key: "lup",
            width: "12%",
            align: "center",
            scopedSlots: { customRender: "lup" },
          },
          {
            title: "Progress",
            key: "pr",
            width: "15%",
            align: "center",
            scopedSlots: { customRender: "pr" },
          },
          {
            title: "Status Progress",
            key: "ac",
            width: "13%",
            align: "center",
            scopedSlots: { customRender: "ac" },
          },
        ];
      return columns;
    },
    innerColumns(){
      const innerColumns = [
        { title: '', key: 'desc', scopedSlots: { customRender: 'desc' } },
        { title: '', key: 'prog', scopedSlots: { customRender: 'prog' }, align: "center", },
        {
          title: '',
          key: 'operation',
          align: "center",
          width: "120px",
          scopedSlots: { customRender: 'operation' },
        },
      ];
      return innerColumns
    },
    historyColumns(){
      const historyColumns = [
        { title: 'PIC', key: 'pic', scopedSlots: { customRender: 'pic' }, align:"center",},
        { title: 'Date', key: 'date', scopedSlots: { customRender: 'date' }, align:"center", },
        { title: 'Progress', key: 'progress', scopedSlots: { customRender: 'progress' }, align:"center",  width:"200px"},
        { title: 'Note', key: 'note', scopedSlots: { customRender: 'note' }, },
      ]
      return historyColumns
    }
  },
  created() {
    this.handleReload("toFirstPage");
  },
  beforeCreate() {
    this.formCreateEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    onChangePagination(e){
      this.handleReload("all")
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.budget_type = "all";
      this.contract_periode = []
      this.due_date_inspection = []
      this.sts = "0"
    },
    intoList(type, value) {
      _.forEach(value, (data, index) => {
        value[index].nomor = index + 1;
      });
      if (type == null) {
        this.datasource = value;
      }
    },
    handleReload(toPage) {
      this.table.loading = true;

      let start_cp = this.contract_periode.length>0 ? moment(this.contract_periode[0]).format(this.getStandartFormatDate) : null
      let end_cp = this.contract_periode.length>0 ? moment(this.contract_periode[1]).format(this.getStandartFormatDate) : null
      let start_ddi = this.due_date_inspection.length>0 ? moment(this.due_date_inspection[0]).format(this.getStandartFormatDate) : null
      let end_ddi = this.due_date_inspection.length>0 ? moment(this.due_date_inspection[1]).format(this.getStandartFormatDate) : null
      let budget = this.budget_type=="all" ? null : this.budget_type
      let searchtxt = this.search ? this.search : null
      let is_close = this.sts == 2 ? null : this.sts
      axios({
        method: "get",
        url: this.$serviceUrl + "progress",
        processData: false,
        params: {
          page: toPage=="toFirstPage" ? 1 : this.currentPage,
          pagesize: 10,
          contract_start_date: start_cp,
          contract_end_date: end_cp,
          inspection_start_date: start_ddi,
          inspection_end_date: end_ddi,
          budget_type: budget,
          search: searchtxt,
          is_close: is_close
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.datasource = response.data
          this.table.loading = false;
        })
        .catch((err) => {
          this.table.loading = false;
          console.log("error : " + err);
        });
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    async handleClickHistory(e){
      this.table.historyKey= e.anggaran_id+e.actor
      this.table.history = true
      await axios({
        method: "get",
        url: this.$serviceUrl + "progress/history",
        processData: false,
        params: {
          actor: e.actor,
          anggaran_id: e.anggaran_id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.modalHistory.data = response.data.data
          this.table.history = false
          this.modalHistory.visible = true
        })
        .catch((err) => {
          this.table.history = false
          console.log("error : " + err);
        });
    },
    handleClickEdit(e){
      this.modalCreate.type = "Edit"
      this.modalCreate.data = e
      this.modalCreate.visible = true
    },
    submitCreateEdit(){
      this.formCreateEdit.validateFields((err, values) => {
        if (err) {
          this.pageLoading = false;
          this.displayMessage("choose-action");
          return;
        }

        this.modalCreate.loadingSave = true

        let postData = new FormData();

        postData.append("actor", this.modalCreate.data.actor);
        postData.append("anggaran_id", this.modalCreate.data.anggaran_id);
        postData.append("progress", values.progress);
        postData.append("note",values.note !== undefined ? values.note : "");

        axios({
          method: "post",
          url: this.$serviceUrl + "progress",
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.modalCreate.loadingSave = false
            this.modalCreate.visible = false
            this.displayMessage("success");
            this.handleReload("currentPage")
          })
          .catch((err) => {
            this.modalCreate.loadingSave = false
            console.log(responses);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    cancelmodalcreate(){
      this.modalCreate.visible = false
    },
    openCloseProject(type, project_id, child){
      let that = this;
      this.$confirm({
        title: 'This Status is '+(type=='Close' ? 'OPEN' : 'CLOSE') +', Are you sure to '+type+' this project?',
        content: "",
        onOk() {
          let url = (type=='Close' ? 'progress/close' : "progress/open");
          let operation_progress = "";
          let financial_progress = "";

          if(type=='Close'){
            if(child[0].actor=='operation progress'){
              operation_progress = child[0].progress;
              financial_progress = child[1] ? child[1].progress : 0;
            }else{
              financial_progress = child[0].progress;
              operation_progress = child[1] ? child[1].progress : 0;
            }
          }

          let data = new FormData();
          data.append("project_id", project_id);
          if(type=='Close'){
            data.append("operation_progress", operation_progress);
            data.append("financial_progress", financial_progress);
          }

          that.openCloseProjectLoading={
            sts: true,
            key: project_id,
          };
          that.asyncAxiosPost(
            url,
            "formdata",
            that.getAuth,
            data
          )
            .then((response) => {
              that.displayMessageValue("success-other", response.message);
              that.openCloseProjectLoading.sts = false;
              that.handleReload("currentPage")
            })
            .catch((err) => {
              that.openCloseProjectLoading.sts = false;
            });
        },
        onCancel() {},
      });
    }
  },
  watch:{
    search(){
      if (this.timerTypeSearch) {
        clearTimeout(this.timerTypeSearch);
        this.timerTypeSearch = null;
      }
      this.timerTypeSearch = setTimeout(() => {
        this.handleReload("toFirstPage")
        this.currentPage = 1
      }, 600);
    },
    budget_type(){
      this.handleReload("toFirstPage")
      this.currentPage = 1
    },
    due_date_inspection(){
      this.handleReload("toFirstPage")
      this.currentPage = 1
    },
    contract_periode(){
      this.handleReload("toFirstPage")
      this.currentPage = 1
    },
    sts(){
      this.handleReload("toFirstPage")
      this.currentPage = 1
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.result {
  margin: @padding 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center !important;
}

.tagsts{
  color: #1abc9c;
}

.ant-progress-outer {
  margin-right: calc(-2em - 5px)!important;
  padding-right: calc(2em + 5px)!important;
}
</style>
